import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { OtpToken, Profile } from './data';

const defaultApi = '/api/profile';
type Item = Profile;

const get = () => {
  return api.get<ApiResponse<Item>>(defaultApi, {
    headers: authHeader(),
  });
};

type UpdateNameParams = {
  fullname: string;
};
const updateName = (body: UpdateNameParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultApi + '/name',
    body,
    {
      headers: authHeader(),
    },
  );
};

type CheckPhoneNumberParams = {
  phoneNumber: string;
};
const checkPhoneNumber = (body: CheckPhoneNumberParams) => {
  return api.post<ApiResponse<OtpToken>>(defaultApi + '/phone', body, {
    headers: authHeader(),
  });
};

type UpdatePhoneParams = {
  phoneNumber: string;
  code: string;
  otpToken: string;
};
const updatePhone = (body: UpdatePhoneParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultApi + '/phone',
    body,
    {
      headers: authHeader(),
    },
  );
};

type UpdateEmailParams = {
  email: string;
  password: string;
};
const updateEmail = (body: UpdateEmailParams) => {
  return api.put<ApiResponse<{ success: boolean }>>(
    defaultApi + '/email',
    body,
    {
      headers: authHeader(),
    },
  );
};

export const profileService = {
  get,
  updateName,
  checkPhoneNumber,
  updatePhone,
  updateEmail,
};
